export function initMyCaptCanNavigation() {
  let navigationSequence = 0;

  function focusTarget(shell, preferResult = false) {
    const target = (preferResult && shell.querySelector(".account-page-result[role]")) || shell.querySelector("h1");
    if (!target) return;
    if (!target.hasAttribute("tabindex")) target.setAttribute("tabindex", "-1");
    target.focus();
  }

  function validateResponse(response) {
    if (!response.ok || !response.headers.get("content-type")?.includes("text/html")) throw new Error("invalid response");
  }

  async function replaceFromResponse(response, preferResult = false, responseText) {
    validateResponse(response);
    const page = new DOMParser().parseFromString(responseText ?? await response.text(), "text/html");
    const next = page.querySelector(".mcc");
    const current = document.querySelector(".mcc");
    if (!next || !current) throw new Error("missing MyCaptCan content");
    current.replaceWith(next);
    document.title = page.title;
    document.dispatchEvent(new CustomEvent("mycaptcan:replace"));
    focusTarget(next, preferResult);
    return page;
  }

  function showNavigationBusy(url) {
    const shell = document.querySelector(".mcc");
    const area = url.pathname.endsWith("/wishlist") ? "wishlist" : "holdbox";
    const template = shell?.querySelector(`[data-mcc-skeleton="${area}"]`);
    const nav = shell?.querySelector(".mcc-nav");
    if (!shell || !template || !nav) return shell;
    shell.setAttribute("aria-busy", "true");
    for (const tab of shell.querySelectorAll(".mcc-nav a")) {
      const active = tab.pathname === url.pathname;
      tab.classList.toggle("is-active", active);
      if (active) tab.setAttribute("aria-current", "page");
      else tab.removeAttribute("aria-current");
    }
    while (nav.nextSibling) nav.nextSibling.remove();
    nav.after(template.content.cloneNode(true));
    return shell;
  }

  async function visit(url, push) {
    const sequence = ++navigationSequence;
    const busyShell = showNavigationBusy(url);
    try {
      const response = await fetch(url, { credentials: "same-origin" });
      if (sequence !== navigationSequence) return;
      validateResponse(response);
      const responseText = await response.text();
      if (sequence !== navigationSequence) return;
      const page = await replaceFromResponse(response, false, responseText);
      if (sequence !== navigationSequence) return;
      if (push) history.pushState({}, page.title, url.pathname + url.search + url.hash);
    } catch {
      if (sequence !== navigationSequence) return;
      busyShell?.removeAttribute("aria-busy");
      if (push) location.href = url.href;
      else location.reload();
    }
  }

  document.addEventListener("click", (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const anchor = event.target.closest?.(".mcc-nav a");
    if (!anchor || anchor.target || anchor.hasAttribute("download")) return;
    const url = new URL(anchor.href);
    if (url.origin !== new URL(location.href).origin || !/^\/apps\/captcan\/(holdbox|wishlist)$/.test(url.pathname)) return;
    event.preventDefault();
    return visit(url, true);
  });

  document.addEventListener("submit", async (event) => {
    const form = event.target.closest?.(".mcc form");
    if (!form || form.method.toLowerCase() !== "post") return;
    const url = new URL(form.action, location.href);
    if (url.origin !== new URL(location.href).origin || !/^\/apps\/captcan\/holdbox\/(preference|schedule)$/.test(url.pathname)) return;
    event.preventDefault();
    if (form.getAttribute?.("aria-busy") === "true" || form.attrs?.["aria-busy"] === "true") return;

    const sequence = ++navigationSequence;
    const controls = Array.from(form.elements);
    const disabledStates = controls.map((control) => control.disabled);
    const submitter = event.submitter || form.querySelector('[type="submit"]');
    const submitText = submitter?.textContent;
    const action = form.querySelector('[name="action"]')?.value;
    const busyText = submitter?.dataset?.busyLabel || (action === "pause" ? "Pausing..." : action === "resume" ? "Resuming..." : action === "cancel" ? "Turning off..." : url.pathname.endsWith("schedule") ? "Scheduling..." : "Saving...");
    const body = new FormData(form);
    form.setAttribute("aria-busy", "true");
    controls.forEach((control) => { control.disabled = true; });
    if (submitter) submitter.textContent = busyText;

    const restore = () => {
      form.removeAttribute("aria-busy");
      controls.forEach((control, index) => { control.disabled = disabledStates[index]; });
      if (submitter) submitter.textContent = submitText;
    };

    try {
      const response = await fetch(url, { method: "POST", body, credentials: "same-origin", redirect: "follow" });
      if (sequence !== navigationSequence) return;
      validateResponse(response);
      const responseText = await response.text();
      if (sequence !== navigationSequence) return;
      await replaceFromResponse(response, true, responseText);
    } catch {
      if (sequence !== navigationSequence) return;
      restore();
      form.submit();
    }
  });

  window.addEventListener("popstate", () => {
    const url = new URL(location.href);
    if (!/^\/apps\/captcan\/(holdbox|wishlist)$/.test(url.pathname)) location.reload();
    else visit(url, false);
  });
}

if (typeof document !== "undefined") initMyCaptCanNavigation();
